/**
 * @page 团队管理/成员列表
 */

import React, { createRef, PureComponent } from 'react';
import BasePageWrap from '&/components/ResourceLib/BasePageWrap';
import BaseModal from '&/components/BaseModal';
import { Button, Form, Input, Space, Table, Image, message, Modal } from 'antd';
import {
    queryMemberList,
    inviteMember,
    modifyInfo,
} from '&/api/personCenter/teamManage';
import { DeleteFilled, InfoCircleFilled } from '@ant-design/icons';
import { formatPhone } from '&/utils/common.js';
import { logoQRcodeGenerate } from '&/utils/commonForPC';
import ShareImage from '&/components/ShareImage';
import './MemberList.scss';

class MemberList extends PureComponent {
    constructor(props) {
        super(props);
        this.codeEl = React.createRef();
    }
    state = {
        result: {
            total: 0,
            list: [],
        },
        isLoading: false,
        queryForm: {
            page: 1,
            pageNum: 10,
            keyword: '',
        },
        inviteData: {},
        visible: false,
        formVisible: false,
        remark: '',
        okLoading: false,
    };

    currentRow = {};

    ref = createRef();

    componentDidMount() {
        this.queryList();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.queryForm.page !== prevState.queryForm.page) {
            this.queryList();
        }
    }

    componentWillUnmount() {}

    queryList = async () => {
        try {
            this.setState({
                isLoading: true,
            });
            const { data } = await queryMemberList(this.state.queryForm);
            this.setState({
                result: {
                    list: data.list,
                    total: data.page?.totalList,
                },
            });
        } finally {
            this.setState({
                isLoading: false,
            });
        }
    };

    onCloseModal = () => {
        this.setState({
            visible: false,
        });
    };

    onOpenModal = () => {
        this.getInviteURL();
        this.setState({
            visible: true,
        });
    };

    closeFormModal = () => {
        this.setState({
            formVisible: false,
        });
    };

    // 两种方式复制到剪切板
    copyLink = async () => {
        if (!this.state.inviteData.url) return;
        const { clipboard } = navigator;
        try {
            if (!clipboard) throw new Error();
            await clipboard.writeText(this.state.inviteData.url);
        } catch {
            this.ref.current.resizableTextArea.textArea.select();
            document.execCommand('copy');
        } finally {
            message.success(intl.get('team.shareToMember'));
        }
    };

    onKeywordChange = e => {
        this.setState({
            queryForm: {
                ...this.state.queryForm,
                keyword: e.target.value,
            },
        });
    };

    handlePageChange = page => {
        this.setState({
            queryForm: {
                ...this.state.queryForm,
                page,
            },
        });
    };
    queryString = {};
    // 获取邀请链接
    getInviteURL = async () => {
        const hideMsg = message.loading(intl.get('base.uploading'), 0);
        try {
            const { data } = await inviteMember();

            const queryString = {
                ...data.url.invitation,
                invUserName: data.url.invUserName,
                type: data.url.type,
            };
            this.queryString = queryString;
            const url = `${
                data.url.domain.m
            }/pages/teamManage/InviteMembers?${new URLSearchParams(
                queryString
            ).toString()}`;
            const code = await logoQRcodeGenerate({ url });
            this.setState({
                inviteData: {
                    url,
                    code,
                    month: data.url.validDay?.month,
                    day: data.url.validDay?.day,
                },
            });
        } finally {
            hideMsg();
        }
    };

    handleCopyImg = event => {
        this.codeEl.current.onCopy();
        event.preventDefault();
    };

    onDelete = ({ id }) => {
        const modal = Modal.confirm({
            content: intl.get('team.warning'),
            okText: intl.get('base.detele'),
            cancelText: intl.get('base.cancel'),
            okButtonProps: { loading: false },
            centered: true,
            onOk: async () => {
                modal.update({ okButtonProps: { loading: true } });
                try {
                    const { msg } = await modifyInfo({
                        id,
                        dop: 2,
                    });
                    message.success(msg);
                    this.queryList();
                } finally {
                    modal.update({ okButtonProps: { loading: false } });
                }
            },
        });
    };

    onEdit = row => {
        this.currentRow = row;
        this.setState({
            formVisible: true,
            remark: row.remark,
        });
    };

    onRemarkChange = ({ target }) => {
        this.setState({
            remark: target.value,
        });
    };

    onSubmitForm = async () => {
        console.log(1);
        this.setState({
            okLoading: true,
        });
        try {
            const { msg } = await modifyInfo({
                id: this.currentRow.id,
                dop: 3,
                remark: this.state.remark,
            });
            message.success(msg);
            this.queryList();
            this.closeFormModal();
        } finally {
            this.setState({
                okLoading: false,
            });
        }
    };

    render() {
        const {
            result,
            isLoading,
            queryForm,
            visible,
            inviteData,
            remark,
            formVisible,
            okLoading,
        } = this.state;
        const columns = [
            {
                title: intl.get('base.serialNum'),
                key: '1',
                width: 70,
                align: 'center',
                render: (_, __, idx) => {
                    return idx + 1 + (queryForm.page - 1) * queryForm.pageNum;
                },
            },
            {
                title: intl.get('projectSpace.nickName'),
                dataIndex: 'username',
                width: '15%',
            },
            {
                title: intl.get('projectSpace.phone'),
                dataIndex: 'mobile',
                width: '15%',
                render: row => formatPhone(row),
            },
            {
                title: intl.get('team.fullName'),
                width: '15%',
                dataIndex: 'real_name',
            },
            {
                title: intl.get('base.remark'),
                dataIndex: 'remark',
            },
            {
                title: intl.get('base.operation'),
                width: 70,
                align: 'center',
                key: '7',
                render: row => {
                    return (
                        <Space>
                            <i
                                style={{ fontSize: 14 }}
                                onClick={() => this.onEdit(row)}
                                // onClick={openForm}
                                className="filled icon-pencil pointer"></i>
                            <DeleteFilled
                                className="pointer"
                                onClick={() => this.onDelete(row)}
                                style={{ fontSize: 14 }}
                            />
                        </Space>
                    );
                },
            },
        ];
        const { Item } = Form;
        const addBtn = (
            <Button type="primary" onClick={this.onOpenModal}>
                {intl.get('projectSpace.addMembers')}
            </Button>
        );

        const subTitle = intl.get('team.inviteToJoinTeam', {
            user: this.queryString.invUserName,
        });

        return (
            <BasePageWrap
                title={intl.get('team.list')}
                className="member-list"
                type="card"
                headerRight={addBtn}>
                <header className="member-list-form">
                    <Item label={intl.get('base.search')}>
                        <Input
                            className="search-ipt"
                            value={queryForm.keyword}
                            placeholder={intl.get('base.keyword')}
                            onChange={this.onKeywordChange}
                            prefix={<i className="icon-search filled" />}
                        />
                    </Item>
                    <Item>
                        <Button onClick={this.queryList}>
                            {intl.get('base.query')}
                        </Button>
                    </Item>
                </header>

                <Table
                    className="normal-table"
                    loading={isLoading}
                    columns={columns}
                    dataSource={result.list}
                    size="small"
                    pagination={{
                        size: 'small',
                        current: queryForm.page,
                        onChange: this.handlePageChange,
                        defaultPageSize: queryForm.pageNum,
                        total: result.total,
                        showSizeChanger: false,
                        style: { marginBottom: 0 },
                        showTotal: total => intl.get('base.total', { total }),
                    }}
                    rowClassName="custom-row"
                />

                <BaseModal
                    getContainer={false}
                    visible={visible}
                    width="36.25rem"
                    title={intl.get('projectSpace.addMembers')}
                    onOk={this.onCloseModal}
                    onCancel={this.onCloseModal}>
                    <div className="share-step">
                        <div className="hint-info">
                            <InfoCircleFilled className="hint-info__icon" />
                            {intl.get('team.shareIndate', {
                                month: inviteData.month,
                                day: inviteData.day,
                            })}
                        </div>
                        <div className="group-name">
                            {intl.get('decorationDesign.shareLink')}
                        </div>
                        <div className="copy-link">
                            <Input.TextArea
                                ref={this.ref}
                                value={inviteData.url}
                                autoSize
                                bordered={false}
                                readOnly></Input.TextArea>
                            <Button type="primary" onClick={this.copyLink}>
                                {intl.get('projectSpace.copyLink')}
                            </Button>
                        </div>
                        <div className="group-name">
                            {intl.get('decorationDesign.qrCodeShare')}
                        </div>
                        <footer className="qrcode">
                            <Image
                                preview={false}
                                className="qrcode-image"
                                src={inviteData.code}></Image>
                            <Button type="primary" onClick={this.handleCopyImg}>
                                {intl.get('projectSpace.copyCode')}
                            </Button>
                        </footer>
                    </div>
                </BaseModal>

                <BaseModal
                    getContainer={false}
                    visible={formVisible}
                    width="23.875rem"
                    title={intl.get('base.edit')}
                    footer={
                        <Space>
                            <Button onClick={this.closeFormModal}>
                                {intl.get('base.cancel')}
                            </Button>
                            <Button
                                type="primary"
                                loading={okLoading}
                                onClick={this.onSubmitForm}>
                                {intl.get('base.confirm')}
                            </Button>
                        </Space>
                    }
                    onCancel={this.closeFormModal}>
                    <div className="form-group">
                        <Form>
                            <Item label={intl.get('projectSpace.nickName')}>
                                {this.currentRow.username}
                            </Item>
                            <Item label={intl.get('projectSpace.phone')}>
                                {formatPhone(this.currentRow.mobile)}
                            </Item>
                            <Item label={intl.get('base.remark')}>
                                <Input.TextArea
                                    showCount
                                    maxLength={255}
                                    autoSize
                                    autoComplete={false}
                                    onChange={this.onRemarkChange}
                                    value={remark}></Input.TextArea>
                            </Item>
                        </Form>
                    </div>
                </BaseModal>
                <ShareImage
                    mainTitle={intl.get('projectMember.teamInvite')}
                    subTitle={subTitle}
                    imgSrc={inviteData.code}
                    ref={this.codeEl}></ShareImage>
            </BasePageWrap>
        );
    }
}

export default MemberList;
